import { GlowFilter } from 'pixi-filters';
import { Container, Graphics, Sprite } from 'pixi.js';
import { TextureFactory } from '../core';

class PatternSymbol extends Container {
  public symbol: number;
  public symbolSprite: Sprite;
  public graphics: Graphics;

  constructor(symbol: number) {
    super();

    this.symbol = symbol;

    const texture = TextureFactory.instance.getSingleTexture(`/textures/pattern/${symbol}.png`);
    this.symbolSprite = new Sprite(texture);
    this.symbolSprite.anchor.set(0.5);
    this.symbolSprite.scale.set(0.75);

    this.graphics = new Graphics();
    this.graphics.beginFill(0x4a282f);
    this.graphics.drawPolygon(0, -20, 7, -26, -7, -26);
    this.graphics.endFill();
    this.graphics.alpha = 0;

    this.addChild(this.graphics);
    this.addChild(this.symbolSprite);
  }

  public glow(): void {
    const colors = [0x77ddff, 0x66cc88, 0xdd66cc, 0xbbddff, 0xff6666];
    this.symbolSprite.filters = [new GlowFilter({ color: colors[this.symbol], distance: 6, quality: 0.1 })];
    this.symbolSprite.scale.set(0.85);
    this.graphics.alpha = 1;
  }

  public removeGlow(): void {
    this.symbolSprite.filters = [];
    this.symbolSprite.scale.set(1);
    this.graphics.alpha = 0;
  }
}

class PatternBar extends Container {
  public symbols: Array<PatternSymbol> = [];
  public currentSymbolIndex: number = 0;

  constructor(symbols: Array<number>) {
    super();

    for (let i = 0; i < symbols.length; i++) {
      const symbol = symbols[i];
      const patternSymbol = new PatternSymbol(symbol);

      this.symbols.push(patternSymbol);
      this.addChild(patternSymbol);
    }

    this.symbols[0].glow();
  }

  public update(elapsed: number): void {
    const SYMBOL_SIZE = 26;

    for (let i = this.symbols.length - 1; i >= 0; i--) {
      const length = this.symbols.length >= Math.ceil((i + 1) / 5) * 5 ? 5 : this.symbols.length % 5;
      const symbol = this.symbols[i];

      symbol.x += ((-(length - 1) * SYMBOL_SIZE) / 2 + (i % 5) * SYMBOL_SIZE - symbol.x) * 0.05 * elapsed;
      symbol.y += (30 + -30 * Math.ceil(this.symbols.length / 5) + Math.floor(i / 5) * 30 - symbol.y) * 0.05 * elapsed;

      if (i < this.currentSymbolIndex) {
        symbol.scale.x += -symbol.scale.x * 0.1 * elapsed;
        symbol.scale.y += -symbol.scale.y * 0.1 * elapsed;

        if (symbol.scale.x <= 0.01) {
          symbol.scale.set(0);
          symbol.removeChild(symbol.parent);
          symbol.destroy();
          this.symbols.splice(i, 1);
          this.currentSymbolIndex--;
        }
      }
    }
  }

  public destroySymbol(symbol: number): boolean {
    if (this.symbols[this.currentSymbolIndex]?.symbol === symbol) {
      this.symbols[this.currentSymbolIndex]?.removeGlow();
      this.currentSymbolIndex++;
      this.symbols[this.currentSymbolIndex]?.glow();
      return true;
    } else {
      return false;
    }
  }
}

export default PatternBar;
